import React, { useEffect, useCallback } from 'react'
import { connect } from 'react-redux'

import { callFileApi, fetchApiDataIfNeeded } from '../../../actions/api'
import { apiResourceEndpoint } from '../../../constants/routes'

import SHSForm from '../../utils/shs-form'
import TextQuestion from './text-question'
import OptionSelectQuestion from './option-select-question'
import ImageQuestion from './image-question'
import InfoQuestion from './info-question'
import ExamplePhoto from './example-photo'
import ImeiQuestion from './imei-question'
import { createSelector } from '@reduxjs/toolkit'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const selectQuestionIds = (state, questionIds) => questionIds
const selectQuestions = state => state.questions
const selectQuestionExamples = state => state.questionExamples

const makeQuestions = createSelector(
    [selectQuestions, selectQuestionIds],
    (questions, questionIds) => {
        return questions.filter(question => questionIds.includes(question.id))
            .sort((a, b) => {
                return questionIds.indexOf(a.id) - questionIds.indexOf(b.id)
            })
    }
)

const makeExamples = createSelector(
    [selectQuestionExamples, selectQuestionIds],
    (questionExamples, questionIds) => {
        return questionExamples.filter(example => questionIds.includes(example.questionId))
    }
)

const mapStateToProps = (state, ownProps) => {
    const questionIds = ownProps.groupQuestions.map(gq => gq.questionId)
    return {
        questions: makeQuestions(state, questionIds),
        examples: makeExamples(state, questionIds)
    }
}


const GroupQuestions = ({ dispatch, activeGroup, installation, groupId, groupQuestions, questions, onSetActiveGroupId, refreshInstallationData, examples }) => {
    const questionIds = groupQuestions.map(gq => gq.questionId)
    const questionFilter = questionIds.map(id => `id|${id}`).join(',')

    useEffect(() => {
        if (questionFilter !== '') {
            const filter = questionFilter.split(',')
            dispatch(fetchApiDataIfNeeded(apiResourceEndpoint('questions', 'LIST'), { 'filter': filter, 'filterMethod': 'OR', 'no-pagination': true }))
        }
    }, [dispatch, questionFilter])

    const renderQuestions = () => {
        let allQuestions = []
        questions.forEach(question => {
            const gq = groupQuestions.find(g => g.questionId === question.id)
            const groupQuestionId = gq?.id
            let questionComponent = null
            switch (question._computed.typeValue) {
            case 'INFORMATIONAL':
                questionComponent = <InfoQuestion installation={installation} question={question} groupQuestionId={groupQuestionId} />
                break
            case 'TEXT':
            case 'NUMERIC':
                questionComponent = <TextQuestion installation={installation} question={question} type="text" groupQuestionId={groupQuestionId} />
                break
            case 'IMAGE':
                questionComponent = <ImageQuestion installation={installation} question={question} groupQuestionId={groupQuestionId} />
                break
            case 'FILE':
                questionComponent = <div>I am a file question</div>
                break
            case 'OPTION_SELECT':
                questionComponent = <OptionSelectQuestion installation={installation} question={question} groupQuestionId={groupQuestionId} />
                break
            case 'DATE':
                questionComponent = <TextQuestion installation={installation} question={question} type="date" groupQuestionId={groupQuestionId} />
                break
            case 'EXAMPLE_PHOTO':
                if (examples) {
                    const example = examples.find(ex => ex.questionId === question.id)
                    questionComponent = <ExamplePhoto example={example} installation={installation} question={question} />
                }
                break
            case 'IMEI':
                questionComponent = <ImeiQuestion installation={installation} question={question} groupQuestionId={groupQuestionId} />
                break
            default:
                // do nothing
            }
            allQuestions.push(
                <div key={groupQuestionId ?? question.id}>
                    {questionComponent}
                </div>
            )
        })
        return allQuestions
    }

    const submitFX = (formData, formId) => {
        dispatch(callFileApi(apiResourceEndpoint('installations', 'UPDATE', installation.id, 'answers'), formData, formId))
    }

    const successFX = useCallback(() => {
        refreshInstallationData()
        onSetActiveGroupId(null)
    }, [refreshInstallationData, onSetActiveGroupId])

    return (
        <>
            <div className="question-group">
                <span className="clickable-icon" onClick={() => onSetActiveGroupId(null)}>
                    <FontAwesomeIcon icon="times" />
                </span>
                <h2>{activeGroup.groupTitle}</h2>
                <SHSForm
                    submitFX={submitFX}
                    successFX={successFX}
                    useFormData={true}
                    buttonLabel={installation._computed.statusDisplay === 'Submitted' ? 'Submitted' : 'Save answers'}
                    buttonDisabled={installation._computed.statusDisplay === 'Submitted' ? 'disabled' : ''}
                >
                    {renderQuestions()}
                </SHSForm>
            </div>
        </>
    )
}

export default connect(mapStateToProps)(GroupQuestions)
